import { render, staticRenderFns } from "./UserLevelList.vue?vue&type=template&id=dec9c29c&scoped=true"
import script from "./UserLevelList.vue?vue&type=script&lang=js"
export * from "./UserLevelList.vue?vue&type=script&lang=js"
import style0 from "./UserLevelList.vue?vue&type=style&index=0&id=dec9c29c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dec9c29c",
  null
  
)

export default component.exports